import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AccountType} from '@ee/common/enums';
import {PricingService, Term} from './pricing.service';
import {Observable} from 'rxjs';
import {ProductResponse} from './models/product-reponse.model';

@Component({
  selector: 'ee-product-comparison',
  template: `
    <table class="product-comparison-table" eeTableStickyHeader [stickyPaddingTop]="paddingTop" [disableStickiness]="disableStickiness">
      <thead>
        <tr class="product-top-row">
          <th class="feature-title">
            Compare plans by Feature
          </th>
          @for (product of (products$ | async)?.products; track product.id; let index = $index) {
            @if (hidePlan !== index) {
              <th class="product-header" [ngClass]="{'highlight': product.highlight}">
                <div class="product-name">{{ product.display_name }}</div>
                @if ((term$ | async); as term) {
                  <div class="product-price">
                    <div class="product-amount">{{ product.prices[term]?.normalized_price | currency }}</div>
                    <div class="per-user">/user/mo</div>
                  </div>
                }
              </th>
            }
          }
        </tr>
      </thead>
      <tbody class="feature-section-wrapper">
        @for (detail of (products$ | async)?.details_table; track detail; let index = $index) {
          <tr class="feature-section">
            <td class="feature-section-name">
              {{ detail.name }}
            </td>
          </tr>
          @for (feature of detail.features; track feature) {
            <tr class="feature">
              <td class="feature-name">
                {{ feature.name }}
                @if (feature.description) {
                  <i class="ml-2 cursor-pointer far fa-question-circle" [tp]="feature.description" [tpDelay]="500"></i>
                }
              </td>
              @for (p of feature.plan_contains; let idx = $index; track idx) {
                @if (hidePlan !== idx) {
                  <td class="product">
                    @if (p === 'y') {
                      <i class="fa fa-check"></i>
                    } @else if (!p) {
                      <i class="fa fa-minus"></i>
                    } @else {
                      <span class="product-feature-desc">
                        {{ p }}
                      </span>
                    }
                  </td>
                }
              }
            </tr>
          }
        }
      </tbody>
    </table>
    <div class="small">
      * Additional setup fee and other charges and limitations may apply. Speak to a sales representative for more details.
    </div>
    `,
  styleUrls: ['./_pricing-common.scss', './product-comparison.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ProductComparisonComponent implements OnInit {
  @Input({required: true}) type: AccountType;
  @Input({required: false}) paddingTop: number = 0;
  @Input() action: string = 'Book a Demo';
  @Input({required: false}) hidePlan: number | null = null;
  @Input({required: false}) disableStickiness: boolean = false;
  @Output() selectPlan = new EventEmitter();

  public products$: Observable<ProductResponse>;
  public term$: Observable<Term>;
  public accountTypes = AccountType;
  public price: number = 0;

  constructor(private pricingService: PricingService) {}

  ngOnInit(): void {
    this.products$ = this.pricingService.getProducts(this.type);
    this.term$ = this.pricingService.selectedPrice$;
  }
}
